import React, { useState } from "react";
import { apiFetch } from "../utils/wkCommon";
import ConfirmDangerDialog from "./ConfirmDangerDialog";
import FolderFormDialog from "./FolderFormDialog";

export default function FolderActions({ user, folder, onChanged }) {
  const [confirm, setConfirm] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingFolder, setEditingFolder] = useState(null);

  const buildFolderLink = (folder) => {
    return `${window.location.origin}/files?folder=${encodeURIComponent(folder.documentId)}`;
  };

  async function remove() {
    await apiFetch(`/api/document-folders/${folder.documentId}`, {
      method: "DELETE",
    });
    onChanged();
  }

  const handleCopyLink = async () => {
    if (!folder) return;

    const link = buildFolderLink(folder);

    try {
      await navigator.clipboard.writeText(link);
      alert("Tautan disalin");
    } catch (err) {
      alert("Gagal menyalin");
    }
  };

  const handleShare = async () => {
    if (!folder) return;

    const link = buildFolderLink(folder);

    if (navigator.share) {
      try {
        await navigator.share({
          title: folder.name,
          url: link,
        });
      } catch (err) {
        console.error(err);
      }
    } else {
      await navigator.clipboard.writeText(link);
      alert("Tautan disalin");
    }
  };

  return (
    <>
      <div className="folder-action-bar">
        <button
          className="icon-btn primary"
          onClick={() => {
            setEditingFolder(null);  // create mode
            setShowForm(true);
          }}
        >
          <img src="/icons/folder-new.png" alt="Folder Baru" />
        </button>

        {folder && (
          <>
            <button
              className="icon-btn secondary"
              onClick={() => {
                setEditingFolder(folder); // edit mode
                setShowForm(true);
              }}
            >
              <img src="/icons/folder-rename.png" alt="Rename" />
            </button>

            <button
              className="icon-btn secondary"
              onClick={handleCopyLink}
            >
              <img src="/icons/link-copy.png" alt="Copy Link" />
            </button>

            <button
              className="icon-btn secondary"
              onClick={handleShare}
            >
              <img src="/icons/link-share.png" alt="Share" />
            </button>

            <button
              className="icon-btn danger"
              onClick={() => setConfirm(true)}
            >
              <img src="/icons/folder-delete.png" alt="Delete" />
            </button>
          </>
        )}
      </div>

      {confirm && (
        <ConfirmDangerDialog
          title="Hapus Folder"
          message={`Folder "${folder.name}" akan dihapus`}
          onConfirm={remove}
          onCancel={() => setConfirm(false)}
        />
      )}

      {showForm && (
        <FolderFormDialog
          user={user}
          folder={editingFolder}
          parentFolder={editingFolder ? null : folder}
          onClose={() => setShowForm(false)}
          onSaved={onChanged}
        />
      )}

    </>
  );
}
